






import { Component, Vue } from 'vue-property-decorator';
import BillingPage from '@/views/Settings/CoinNetworkPlan/CoinNetworkPlan.vue';

@Component({
  components: {
    BillingPage
  }
})
export default class Billing extends Vue {}
